import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import {Tag} from 'antd';
import {map} from 'lodash';
import {TermFilter} from '@dofleini/query-builder';
import ClientsEstablishmentApiService from '@/services/ClientsEstablishmentApiService';
import {useGetAllEstablishments} from '@/modules/clients/hooks/useClientsEstablishment';

const SelectUserEstablishments = ({value, onChange, translation, setEstablishments, establishments, setEstablishmentsValues, user, ...props}) => {

  const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v?._id || v) : undefined;
  }, [value]);

  const handleOnChange = useCallback((value) => {
    setEstablishmentsValues(value);
    onChange(value);
  }, [onChange, setEstablishmentsValues]);

  const setEntities = useCallback((entities) => {
    if ((!establishments || establishments.length === 0) && entities?.length > 0) {
      setEstablishments(entities);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SelectElementCmp
      queryKey={'user-establishments'}
      service={ClientsEstablishmentApiService}
      customMethod="/ms-core/api/establishments/search-for-client-users"
      includeValue={''}
      value={currentValue}
      onChange={handleOnChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      placeholder={!user ? translation('placeholderSelectServices') : '-'}
      nameToShow={'name'}
      mode={'multiple'}
      afterLoadData={setEntities}
      additionalParams={{
        forceSize: true,
        size: 1000,
        useProjections: true,
        projections: {
          name: 1,
          servicesTemplatesGoal: 1,
        }
      }}
      {...props}
    />
  );
};

SelectUserEstablishments.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  isViewMode: PropTypes.func,
  translation: PropTypes.func,
  setEstablishments: PropTypes.func,
  establishments: PropTypes.array,
  setEstablishmentsValues: PropTypes.func,
  user: PropTypes.string
};

// eslint-disable-next-line no-unused-vars
const SelectUserEstablishmentsView = ({value, entity}) => {
  const filter = useMemo(() => {
    return new TermFilter({field: '_id', value: { $in: value } }).toQuery();
  }, [value]);
  
  const {data} = useGetAllEstablishments(filter);

  const tagsRender = useCallback((value) => {
    return (<div className='flex flex-wrap'>
      {map(value, (item) => (
        <div key={`tag-${item['_id']}`} className="pb-2">
          <Tag className="px-2 py-1">
            {item['name']}
          </Tag>
        </div>
      ))}
    </div>);
  }, []);

  return (
    <>
      {tagsRender(data|| [])}
    </>
  );
};

SelectUserEstablishmentsView.propTypes = {
  value: PropTypes.string,
  entity: PropTypes.object,
};

export default memo(SelectUserEstablishments);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {object} entity this is entity type
 * */
export const renderUserEstablishments = (text, entity) => {
  return (
    <SelectUserEstablishmentsView value={text} entity={entity}/>
  );
};

